import { useEffect, useState } from "react";
import { FoundationsButton } from "../../GenericComponents/button"
import { FoundationsCheckBox } from "../../GenericComponents/checkbox"
import { FoundationsInput } from "../../GenericComponents/input"
import FoundationsSelect from "../../GenericComponents/select";
import Dialog from "../../GenericComponents/dialog";
import { UserMessages } from '../../Redux/VisualUnitTarget/VisualUnitTargetEnums'
import { useSavetargetMutation, useDeletetargetMutation } from "../../Redux/VisualUnitTarget/VisualUnitTargetSlice";
import { FoundationsEnums } from '../../enum'
import { checkUserPrivileges, forceNumberAndDurationOnly } from "../../GlobalMethods";
import { useSelector } from "react-redux";
import { getCurrentUserData, RootState } from "../../Redux/store";
import { FoundationsGenericToaster } from "../../GenericComponents/FoundationsGenericToaster";
import { getDurationDisplayFromSecs } from "../Charts/chartHelperFunctions";

declare let window: any
const UnicornApp = window.unicornInstance as any

export function TargetRubric(props: any) {
    const measureIndex = Number(props.measureIndex1);
    const vuDetails = props.executeResult?.vuDetails?props.executeResult?.vuDetails:props.vuDetails;
    const measureList = vuDetails.MeasureList[measureIndex];
    const isAutoRefresh = props.isAutoRefresh;
    const currentValue = JSON.parse(props.executeResult?.reportData)?.ComputedData[measureIndex].DataPoint;
    // Initialize states based on `initialize` method
    const metaDataId = measureList.MetaDataId;
    const defaultTargetId = measureList.DefaultTargetId;
    const userTargetInfo = measureList.UserTarget;
    const userRubricInfo = measureList.UserRubric;
    const userTargetId = measureList.UserTargetId;
    const userRubricId = measureList.UserRubricId || 0;
    const dataTypeString = measureList.SingleValueReportId > 0 ? measureList.SingleValueReport.MeasureList[0].MetaData.DataType.toString() : measureList.MetaData.DataType.toString()
    const targetInfo = userTargetId > 0 ? userTargetInfo : defaultTargetId > 0? measureList.DefaultTarget : "";
    //#region  FP-10321. Get first measure details from SingleValueReport if the report is cascade report.
    // const measureAggregate = measureList.SingleValueReport != null ? measureList.SingleValueReport.MeasureList[0].AggregateFunctionName : measureList.AggregateFunctionName;
    const measureAggregate = measureList.AggregateFunctionName;
    const measureName = measureList.SingleValueReport != null ? measureList.SingleValueReport.MeasureList[0].MetaData?.FieldName : measureList.MetaData?.FieldName;
    const [targetValue, setTargetValue] = useState<any>('');
    const [targetType, setTargetType] = useState(-1);
    const [neutralRubricMessage, SetNeutralRubricMessage] = useState("");
    const [targetInputType, setTargetInputType] = useState(0);
    const [emailChecked, setEmailChecked] = useState(false);
    const [placeHolderText, setPlaceHolderText] = useState('');
    const [presetExists, setPresetExists] = useState(false);
    const [kmiSet, setKmiSet] = useState(false);
    const [usingPreset, setUsingPreset] = useState(false);
    const [presetPermission, setPresetPermission] = useState(false);
    const [updatePreset, UpdatePreset] = useState(false);
    //   const [emailCheckVisible, setEmailCheckVisible] = useState(false);
    //   const [autoRefresh, setAutoRefresh] = useState(isAutoRefresh);
    const [BPValue, setBPvalue] = useState("");
    const [selectedBPId, setselectedBPId] = useState<any>('')
    const [errorMessage, setErrorMessage] = useState("");
    const [openDialog, setDialogopen] = useState(true);
    const [Savetarget,  { isLoading: saveloading, error: saveerror }] = useSavetargetMutation();
    const [Deletetarget, { isLoading: deleteloading, error: deleteerror}] = useDeletetargetMutation();
    const getDisplayRubricValue = (value: any) => {
        if (dataTypeString == FoundationsEnums.HLDataType.HLDuration) {
            return getDurationDisplayFromSecs(value, true);
        }
        else { return value; }
    }
    const currentUserData = useSelector(
        (state: RootState) => getCurrentUserData(state)
    )
    const checkTargetIsValid = () => {
        //if(targetInputType == 1) return true;

        var validTarget = true;
        if ((targetValue != ""||BPValue!="") && dataTypeString == FoundationsEnums.HLDataType.HLDuration) {
            var durationObj = targetInputType == 1 ? window.healthLevelGlobal.parseDuration(BPValue) : window.healthLevelGlobal.parseDuration(targetValue);
            if (durationObj.valid) {
                validTarget = true;
            }
            else {
                validTarget = false;
            }

        }
        else if(targetValue != "" && isNaN(targetValue)) {
            validTarget = false;
        }
        else if(targetValue.length > 10) {
            setErrorMessage("The target value should not exceed 10 digits. Please enter a valid value.");
            return false;
        }
        

        if (!validTarget) {
            var key = window.healthLevelGlobal.GetKeyByValue(FoundationsEnums.HLDataType, dataTypeString.toString());
            setErrorMessage(window.healthLevelGlobal.HLDataTypeValidationMessages[key]);
            return false;
        }
        return true;


    }
const togglepreset=(val:boolean)=>
{  
    val&&(
        setTargetValue(measureList.DefaultTarget.TargetInputType == 0 && (measureList.DefaultTarget.TargetValue == 0 || measureList.DefaultTarget.TargetValue)
        ? getDisplayRubricValue(measureList.DefaultTarget.TargetValue) + ""
        : ""),

    // Set additional target-related states
    setTargetType(measureList.DefaultTarget.TargetType),
    setTargetInputType(measureList.DefaultTarget.TargetInputType),
    setselectedBPId(measureList.DefaultTarget.TargetInputType == 1 ? measureList.DefaultTarget.TargetValue:"")

    )
}


const closeDialog =()=> {
    const fadeElements = document.querySelectorAll(`.vu-container:not(#new_vus_${props.vuId})`);
    fadeElements.forEach((element:any) => {
      Object.assign(element.style, {  transition: "opacity 0.1s ease",
        opacity: "1"}); // Spread the `style` object directly
    });
    props.closeKMI()
    setDialogopen(false);

}

    const SaveTarget = () => {

        if (targetType == -1) {
            setErrorMessage(UserMessages.MissingTargetType);
            return;
        }
        else if((targetInputType==0&&targetValue=="")||(targetInputType==1&&selectedBPId == -1))
        {
            setErrorMessage(UserMessages.MissingTargetValue);
            return;
        }
 
        var callSave = checkTargetIsValid();
        if(updatePreset&&measureList.DefaultTarget.TargetType != 0&& callSave)
         { callSave= confirm("This preset may be in use by other users for KMI notifications. Do you wish to continue?") }
        callSave && Savetarget({

            TargetInputType: targetInputType,
            defaultTargetId: defaultTargetId,
            userTargetId: userTargetId,
            userRubricId: userRubricId,
            dashBoardId: props.dashboardId,
            visualUnitId: props.vuId,
            metaDataId: metaDataId,
            aggregateFunction: measureAggregate,
            targetValue:targetInputType == 0 &&(
                dataTypeString == FoundationsEnums.HLDataType.HLDuration ?
                window.healthLevelGlobal.parseDuration(targetValue)?.totalSeconds : targetValue) || targetInputType ==1 && selectedBPId,
            targetType: targetType,
            changePreset: updatePreset,//set global measure
            setKMI: kmiSet,
            emailNotifyOnce: emailChecked,
            DataType: dataTypeString, //FP-10376.
            usePreset: usingPreset,
            subvisualUnitId: measureList?.SingleValueReportId
        }).unwrap().then((response) => {
            if (response != null) {
                var resultData = response.data;
                if (resultData != null) {
                    if (!response.statusMessage || response.statusMessage == "Success") {
                        closeDialog()
                        props.refreshReport();
                        if (resultData.MessageResults.length > 0) {
                            if (resultData.MessageResults[0].HelpMessage == FoundationsEnums.Status.Success) {
                                FoundationsGenericToaster("success", resultData.MessageResults[0].Message) 
                            }
                           
                        }
                    }
                    else {
                        setErrorMessage(UserMessages.InvalidData);
                    }
                }
                else {
                    setErrorMessage(response.statusMessage);
                }
            }

        }).catch((error) => {
            setErrorMessage(UserMessages.GenericError);
        });
    
        
    }
    const DeleteTarget = () => {
        if ((updatePreset && defaultTargetId > 0) || (!updatePreset && userTargetId > 0)) {
            var callDelete = true;
            if(updatePreset)
            {
            callDelete = confirm("This preset may be in use by other users for KMI notifications. Do you wish to continue?");
            }
            callDelete&&Deletetarget( {
                visualUnitId: props.vuId,
                metaDataId: metaDataId,
                aggregateFunction: measureAggregate,
                userTargetId: userTargetId,// send usertargetid always (in case of use preset this user will derefernce from global target usage)
                defaultTargetId: defaultTargetId,
                userRubricId: userRubricId,
                changePreset: updatePreset,
                subvisualUnitId: measureList?.SingleValueReportId
            }).unwrap().then((response) => {
                if (response != null) {
                    var resultData = response.data;
                    if (resultData != null) {
                        if (!response.statusMessage || response.statusMessage == "Success") {
                            closeDialog()
                            props.refreshReport();
                            FoundationsGenericToaster("success", "Target configuration has been deleted");
                        }
                        else
                        {
                            setErrorMessage(UserMessages.DeleteFailed)
                        }
                    }
                }
    
            }).catch((error) => {
                setErrorMessage(UserMessages.DeleteFailed);
            });
           
        }
        else if (updatePreset) {
           setErrorMessage(UserMessages.NoGlobalTarget);
        } else {
            setErrorMessage(UserMessages.NoUserTarget);
        }
    }
    // Manipulating data and setting the state inside useEffect
    useEffect(() => {
        const initializeData = async () => {
        const fadeElements = document.querySelectorAll(`.vu-container:not(#new_vus_${props.vuId})`);
        fadeElements.forEach((element:any) => {
          Object.assign(element.style, { transition: "opacity 0.1s ease",
            opacity: "0.3" }); // Spread the `style` object directly
        });
        
        const BPvalue = targetInfo.TargetInputType == 1 && 
            props.BusinessParamsList.find(
                (parameter: any) => parameter.Id == targetInfo.TargetValue
            )?.BPValue;
        setBPvalue(BPvalue);
let targetvalue = targetInfo.TargetInputType==0&&(targetInfo.TargetValue == 0 || targetInfo.TargetValue)
? getDisplayRubricValue(targetInfo.TargetValue) + ""
: "";
        setTargetValue(targetvalue);

        // Set additional target-related states
        let TargetType = targetInfo.TargetType ?? -1;
        let TargetValue = targetInfo.TargetInputType == 0 ? targetvalue : targetInfo.TargetInputType== 1 ? BPvalue : "";
        setTargetInputType(targetInfo.TargetInputType ?? 0);
        setselectedBPId(targetInfo.TargetInputType == 1 ? targetInfo.TargetValue : -1);
        setEmailChecked(userRubricInfo?.emailnotify);
        setTargetType(TargetType);

        // Placeholder logic
        const key = window.healthLevelGlobal.GetKeyByValue(FoundationsEnums.HLDataType, dataTypeString);
        const placeholder = window.healthLevelGlobal.HLDataTypePlaceholders[key] || "Value";
        setPlaceHolderText(placeholder);

        // Preset and KMI logic
        const presetExistsCheck = measureList.DefaultTarget?.TargetType != 0;
        setPresetExists(presetExistsCheck);
        let Kmiset = userRubricInfo?.Id > 0;
        let usingPreset = presetExistsCheck && (userTargetId < 1 && defaultTargetId > 0);
        setKmiSet(Kmiset);
        setUsingPreset(usingPreset);

        Kmiset ? ( TargetType == -1 && SetNeutralRubricMessage(UserMessages.SetKMI)
        ||TargetType == 1 &&  SetNeutralRubricMessage(`${UserMessages.StayUnderHelptext} of ${TargetValue}`)
        ||TargetType == 2 && SetNeutralRubricMessage(`${UserMessages.StayCloseToHelptext} of  ${TargetValue}`)
        ||TargetType == 3 && SetNeutralRubricMessage(`${UserMessages.AimToExceedHelptext} of  ${TargetValue}`)
       ):usingPreset && SetNeutralRubricMessage(UserMessages.UseGlobal)

        
        // Set preset permission
        setPresetPermission(checkUserPrivileges(currentUserData,"AllowChangePresetTarget"));


    }
    initializeData();
 }, []);

    useEffect (() =>{
        setErrorMessage("");
    },[targetInputType,targetType,targetValue,selectedBPId,usingPreset,updatePreset,emailChecked,kmiSet])



    return (
        <>
            <Dialog 
                isOpen={openDialog} 
                title={(measureName ? 'Assign target for ' + measureAggregate + ' ' + measureName : "Edit Target")} 
                width={750} onClose={()=>closeDialog()} contentStyles={{overflow:'hidden'}}
                buttons={[
                    {
                      label: updatePreset ? "Delete Global Target" : "Delete Personal Target",
                      id: "delete_target_button",
                      onClick: DeleteTarget,
                      disabled: (!updatePreset && userTargetInfo.Id == -1) || usingPreset,
                      className: "ui-button ui-corner-all ui-widget app-button negative",
                    },
                    {
                      label: updatePreset ? "Set Global Target" : "Set Personal Target",
                      id: "save_target_button",
                      onClick: SaveTarget,
                      className: "ui-button ui-corner-all ui-widget app-button",
                      // customStyle: { paddingBottom: "8px" },                     
                    },
                ]}
            >         
                <div className="field-value-wrapper pb-0" style={{ fontSize: '14px' }}>
                    <span>
                        <span id="rubric_value_label" className="label">Current value: {currentValue} </span>
                        <span id="rubric_value_display" className="value"> </span>
                    </span>
                </div>

                <span id="edit-rubric-table" className="input-form-table-popup-window" style={{ width: '100%' }}>
                    <span className="rubric-row row px-3 mt-3">
                        <FoundationsSelect 
                            classes="form-group mr-2" 
                            id='target_type_selectbox'
                            name="target type select" 
                            containerClasses="d-inline-block field-target-select" 
                            selectClasses="h-100"
                            isMultiSelect={false} 
                            disabled={usingPreset} 
                            toolTipText="Choose to enter a manual target or business parameter for this target"
                            tooltipClasses="tooltip-icons ml-2"
                            onChange={(event: any) => {
                                setTargetInputType(parseInt(event.target.value));
                            }}
                        >
                            <option value="0" selected={targetInputType == 0}> User Defined </option>
                            <option value="1" selected={targetInputType == 1}> Use Business Parameter</option>
                        </FoundationsSelect>

                        <FoundationsSelect 
                            classes="form-group mr-2" 
                            id='target_selectbox'
                            name="target_select" 
                            containerClasses="d-inline-block field-target-select" 
                            selectClasses="h-100"
                            disabled={usingPreset}
                            isMultiSelect={false}
                            toolTipText="Choose which criteria to use for setting measure targets and sending KMI notifications"
                            tooltipClasses="tooltip-icons ml-2"
                            value={targetType}
                            onChange={(event: any) => {
                                let TargetType = event.target.value;
                                let TargetValue = targetInputType == 0 ? targetValue : targetInputType == 1 ? BPValue : "";
                                kmiSet && ( TargetType == -1 && SetNeutralRubricMessage(UserMessages.SetKMI)
                                 ||TargetType == 1 &&  SetNeutralRubricMessage(`${UserMessages.StayUnderHelptext} of ${TargetValue}`)
                                 ||TargetType == 2 && SetNeutralRubricMessage(`${UserMessages.StayCloseToHelptext} of  ${TargetValue}`)
                                 ||TargetType == 3 && SetNeutralRubricMessage(`${UserMessages.AimToExceedHelptext} of  ${TargetValue}`)
                                )
                                setTargetType(parseInt(TargetType))
                            }}>
                            <option value="-1" > - Target Type - </option>
                            <option value="1" selected={targetType == 1} > Stay Under </option>
                            {/* {{!-- FP-9997 Enabling "stay close to" --}} */}
                            <option value="2" selected={targetType == 2} > Stay Close To</option>
                            <option value="3" selected={targetType == 3} > Aim to Exceed </option>
                        </FoundationsSelect>
                        
                        {targetInputType == 0 && (
                            <FoundationsInput 
                                classes={"mr-2 form-group"}
                                id="text_target_value"
                                type="text" 
                                name='first_name'
                                inputClasses="field-target-value" 
                                containerClasses="d-inline-block field-target-select"
                                toolTipText="Enter the threshold values for targets and KMI Notifications"
                                tooltipClasses="tooltip-icons ml-2"
                                maxLength={30} 
                                value={targetValue} 
                                placeHolder={placeHolderText}
                                disabled={usingPreset} 
                                customStyle={{
                                    display: 'inline-flex',
                                    alignItems: 'middle',
                                    position: 'relative', 
                                    top: '3px',        
                                }}
                                onInput={(event: any) => {
                                    let TargetValue = event.target.value;

                                    kmiSet && ( targetType == -1 && SetNeutralRubricMessage(UserMessages.SetKMI)
                                    ||targetType == 1 &&  SetNeutralRubricMessage(`${UserMessages.StayUnderHelptext} of ${TargetValue}`)
                                    ||targetType == 2 && SetNeutralRubricMessage(`${UserMessages.StayCloseToHelptext} of  ${TargetValue}`)
                                    ||targetType == 3 && SetNeutralRubricMessage(`${UserMessages.AimToExceedHelptext} of  ${TargetValue}`)
                                   )
                                    setTargetValue(event.target.value) 
                                }} 
                                onKeyDown = {forceNumberAndDurationOnly} 
                            >
                        </FoundationsInput>)}

                        {targetInputType == 1 && (
                            <FoundationsSelect 
                                classes={" mr-2 form-group "}
                                id='business_parameter_target_selectbox'
                                name="business parameter select"
                                isMultiSelect={false} 
                                containerClasses="d-inline-block field-target-select" 
                                selectClasses="h-100 maxWdith250px"
                                disabled={usingPreset}
                                toolTipText="Select a business parameter to use as the target value"
                                tooltipClasses="tooltip-icons ml-2 " 
                                onChange={(event: any) => {
                                    let BpId = event.target.value
                                    let TargetValue =BpId > -1? props.BusinessParamsList.find((parameter: any) => parameter.Id == BpId)?.BPValue:"";

                                    kmiSet && ( targetType == -1 && SetNeutralRubricMessage(UserMessages.SetKMI)
                                    ||targetType == 1 &&  SetNeutralRubricMessage(`${UserMessages.StayUnderHelptext} of ${TargetValue}`)
                                    ||targetType == 2 && SetNeutralRubricMessage(`${UserMessages.StayCloseToHelptext} of  ${TargetValue}`)
                                    ||targetType == 3 && SetNeutralRubricMessage(`${UserMessages.AimToExceedHelptext} of  ${TargetValue}`)
                                   )
                                    setselectedBPId(BpId);
                                    setBPvalue(TargetValue);                                   
                                }}
                            >
                            <option value={-1}>-no parameter-</option>
                            {
                                props.BusinessParamsList.map((parameter: any) => (
                                    <option value={parameter.Id} selected={selectedBPId == parameter.Id} >{parameter.Name + "(" + parameter.BPValue + ")"}</option>
                                ))

                            }
                            </FoundationsSelect>)
                        }

                    </span>
                    <span className="rubric-row row px-3 mt-3">
                        {/* {{!-- removed title from the tag below FP-9333 --}} */}

                        {presetPermission && (
                            <FoundationsCheckBox 
                                id="checkbox_preset_target"
                                name="preset_target" 
                                containerClasses="mr-4" 
                                inputClasses="range-checkbox-alignment"
                                labelText="Update Preset" 
                                labelClasses="ml-2px verticalAlignSuper"
                                toolTipText='Select this option to set a global preset measure target or un-select this option to set a personalized target.'
                                tooltipClasses="tooltip-icons ml-1 verticalAlignSuper"
                                disabled={usingPreset} 
                                customStyle={{ float: 'right', whiteSpace: 'nowrap' }}
                                onChange={(event) => {
                                    UpdatePreset(event.target.checked)
                                }} />

                        )}

                        {presetExists &&
                            <FoundationsCheckBox 
                                id="checkbox_use_preset"
                                name="use_preset" 
                                containerClasses=" mr-4 " 
                                inputClasses="range-checkbox-alignment"
                                labelText="Use Preset" 
                                labelClasses="ml-2px verticalAlignSuper"
                                toolTipText='Select this option to use the global preset measure target set by the admin. Un-select this option to use your personalized target.' checked={usingPreset}
                                tooltipClasses="tooltip-icons ml-1 verticalAlignSuper"
                                customStyle={{ float: 'right', whiteSpace: 'nowrap' }}
                                disabled={updatePreset}
                                onChange={(event) => {
                                    let Usingpreset = event.target.checked;
                                    Usingpreset&&SetNeutralRubricMessage(UserMessages.UseGlobal)
                                    setUsingPreset(Usingpreset)
                                    togglepreset(Usingpreset);
                                }}
                            >
                            </FoundationsCheckBox>
                        }
                        <FoundationsCheckBox 
                            id="checkbox_set_kmi"
                            name="set_kmi" 
                            containerClasses="mr-4 " 
                            inputClasses="range-checkbox-alignment"
                            labelText="Keep me Informed" 
                            labelClasses="ml-2px verticalAlignSuper"
                            toolTipText='Once the global preset measure target or a personalized target is set, select this option to receive the KMI email notifications for the set target to track the set target and stay informed.' checked={kmiSet}
                            tooltipClasses="tooltip-icons ml-1 verticalAlignSuper"
                            customStyle={{ float: 'right', whiteSpace: 'nowrap' }}
                            onChange={(event) => {
                             
                                let TargetValue = targetInputType == 0 ? targetValue : targetInputType == 1 ? BPValue : "";
                                let Kmiset = event.target.checked;  
                                Kmiset ? ( targetType == -1 && SetNeutralRubricMessage(UserMessages.SetKMI)
                                 ||targetType == 1 &&  SetNeutralRubricMessage(`${UserMessages.StayUnderHelptext} of ${TargetValue}`)
                                 ||targetType == 2 && SetNeutralRubricMessage(`${UserMessages.StayCloseToHelptext} of  ${TargetValue}`)
                                 ||targetType == 3 && SetNeutralRubricMessage(`${UserMessages.AimToExceedHelptext} of  ${TargetValue}`)
                                ):usingPreset?SetNeutralRubricMessage(UserMessages.UseGlobal):SetNeutralRubricMessage("");
                                setKmiSet(Kmiset)
                            }}  
                        >
                        </FoundationsCheckBox>
                        {/*  removed title from the tag below FP-9333 */}
                        {isAutoRefresh && kmiSet && 
                            <FoundationsCheckBox 
                                containerClasses="mr-4 measure_rubric_checkbox" 
                                id="checkbox_email_notify_once"
                                name="checkbox_email_notify_once" 
                                inputClasses="range-checkbox-alignment"
                                labelText="Email once per day" 
                                labelClasses="ml-2px verticalAlignSuper" 
                                checked={emailChecked}
                                toolTipText='Send KMI email notifications once per day'
                                tooltipClasses="tooltip-icons ml-1 verticalAlignSuper"
                                customStyle={{ float: 'right' }} onChange={(event) => {
                                    let Emailchecked = event.target.checked;
                                    Emailchecked?SetNeutralRubricMessage(UserMessages.SetEmail):SetNeutralRubricMessage("");
                                    setEmailChecked(Emailchecked)
                                }}  
                            >
                            </FoundationsCheckBox>
                        }
                        {/*!--Fixed tool tip text of email once per day--*/}
                    </span>
                </span>
                <div>
                
                    {errorMessage && (<div id="valmsg_save_rubric_error" className="padding-left-small padding-top-small field-validation-error" style={{display:"block"}}>{errorMessage}</div>)}
                    {!errorMessage&&
                    <div id="valmsg_save_rubric_neutral" className="padding-left-small padding-top-small field-validation-neutral">
                        { neutralRubricMessage
                          }
                    </div>
                    }

                    {/* <div id="valmsg_save_rubric_success" className="padding-left-small padding-top-small field-validation-success"></div> */}

                </div>
                
            </Dialog>
        </>
    )
}

